module.exports = __webpack_public_path__ + "static/media/bi.012fdc26.svg";